import { interval as observableInterval } from 'rxjs';
import { Component, OnInit, Inject, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { IAppState } from '../app.state';
import { selectShare, selectItem } from './share.actions';

@Component({
  selector: 'nns-share-uploading',
  template: `
    <div class="nns-wrapper" flex layout="row" layout-align="center start">
      <div class="nns-error-page-content" flex="none" layout="column" layout-align="center center">
        <div class="nns-error-page-title">Uploading...</div>
        <div class="nns-error-page-desc">Please wait</div>
      </div>
    </div>
  `,
  styles: [`
    :host {
      position:relative;
      box-sizing:border-box;
      padding:105px 0;
    }
    .nns-error-page-content {text-align:center;}
    nns-error-page .nns-wrapper {
      max-width:970px;
      min-width:320px;
      margin:0 auto;
      padding:0 10px;
    }
    .nns-error-page-type {
      font-weight:bold;
      font-size:235px;
      color:#EBEFF1;
      letter-spacing:-5.91px;
      line-height:1;
    }
    .nns-error-page-title {
      font-weight:bold;
      font-size:32px;
      color:#3C4849;
      padding:0 0 14px 0;
      line-height:1.3;
    }
    .nns-error-page-desc {
      font-size:18px;
      color:#2F3737;
    }
    @media only screen and (max-width: 768px) {

      .nns-error-page-type {
        font-size:150px;
        letter-spacing:-3.77px;
      }
      .nns-error-page-title {font-size:20px;}

    }
    :host-context(.nns-theme-night) .nns-error-page-title,
    :host-context(.nns-theme-night) .nns-error-page-desc{
      color: #fff;
    }
  `]
})
export class ShareUploadingComponent implements OnInit {
  isBrowser;
  @Input() share;
  subscription;

  constructor(
    @Inject('isBrowser') isBrowser,
    public _store: Store<IAppState>
  ) {
    this.isBrowser = isBrowser;
  }

  ngOnInit() {
    if (this.isBrowser) {
      const refreshTimer$ = observableInterval(2000);

      this.subscription = refreshTimer$.subscribe(() => {
        if (this.isBrowser) {
          const {id, securityKey, note} = this.share.instance;
          if (note) {
            return;
          }
          this._store.dispatch(selectShare(id, securityKey, true));
          this._store.dispatch(selectItem(undefined));
        }
      });
    }
  }

  ngOnDestroy() {
    if (this.isBrowser) {
      this.subscription.unsubscribe();
    }
  }
}
